import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VToolbarItems } from 'vuetify/lib/components/VToolbar';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VToolbarItems,_vm._l((_vm.exportsData),function(exp,index){return _c(VBtn,{key:index,attrs:{"text":"","icon":"","color":_vm.color || exp.COLOR || 'primary',"href":_vm.getDownloadLink(exp.PARAMS),"target":"_blank","title":exp.TXT}},[_c(VIcon,[_vm._v(_vm._s(exp.ICON || 'mdi-file'))])],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }